import { Box, Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Stack, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { changePasswordStaff } from "../../Api/Staff";
import { UserObjectStore } from "../../ObjectStore/UserObjectStore";

export interface ChangePasswordDialogProps {
    open: boolean
    dialogProps?: Omit<DialogProps, "open">
    onClose: () => void
}
export function ChangePasswordDialog({
    open,
    dialogProps,
    onClose,
}: ChangePasswordDialogProps): React.ReactElement {
    let { enqueueSnackbar } = useSnackbar()
    let { userObjectState } = React.useContext(UserObjectStore)

    const [loginPass, setLoginPass] = React.useState<string>("")
    const [newLoginPass, setNewLoginPass] = React.useState<string>("")
    const [newLoginPassConfirm, setNewLoginPassConfirm] = React.useState<string>("")

    const [saveEnable, setSaveEnable] = React.useState<boolean>(false)

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const doSave = React.useCallback(() => {
        if (userObjectState.stfId && newLoginPass === newLoginPassConfirm) {
            changePasswordStaff({
                stf_id: userObjectState.stfId,
                login_pass: loginPass,
                new_login_pass: newLoginPass
            }, {signal: abortController.signal}).then(() => {
                enqueueSnackbar("パスワードを変更しました", { variant: "success" })
                onClose()
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
    }, [abortController, userObjectState, loginPass, newLoginPass, newLoginPassConfirm, onClose, enqueueSnackbar])

    React.useEffect(() => {
        setLoginPass("")
        setNewLoginPass("")
        setNewLoginPassConfirm("")
    }, [open])

    React.useEffect(() => {
        let _saveEnable = true;
        if (loginPass.length === 0) {
            _saveEnable = false
        }
        if (newLoginPass.length === 0 || newLoginPass !== newLoginPassConfirm) {
            _saveEnable = false
        }
        setSaveEnable(_saveEnable)
    }, [loginPass, newLoginPass, newLoginPassConfirm])

    return (
        <Dialog
            {...dialogProps}
            open={open}
            onClose={() => {
                onClose()
            }}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>ログインパスワード変更</DialogTitle>
            <DialogContent>
                <Stack
                    spacing={2}
                >
                    <Box>
                        <TextField
                            label="今までのログインパスワード"
                            value={loginPass}
                            onChange={e => {
                                setLoginPass(e.target.value)
                            }}
                            helperText="今までのログインパスワードを入力してください"
                            fullWidth
                            size="small"
                            type={"password"}
                        />
                    </Box>
                    <Box>
                        <TextField
                            label="新しいログインパスワード"
                            value={newLoginPass}
                            onChange={e => {
                                setNewLoginPass(e.target.value)
                            }}
                            helperText="新しいログインパスワードを入力してください。8〜24文字が設定可能で、半角英数字とハイフン、アンダーバー、が利用可能です。"
                            fullWidth
                            size="small"
                            type={"password"}
                        />
                    </Box>
                    <Box>
                        <TextField
                            label="新しいログインパスワード(確認)"
                            value={newLoginPassConfirm}
                            onChange={e => {
                                setNewLoginPassConfirm(e.target.value)
                            }}
                            helperText="新しいログインパスワードで設定したパスワードを再度入力してください。"
                            fullWidth
                            size="small"
                            type={"password"}
                        />
                    </Box>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        onClose()
                    }}
                >キャンセル</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        doSave()
                    }}
                    disabled={!saveEnable}
                >パスワードを変更</Button>
            </DialogActions>
        </Dialog>
    )
}